import React from "react";

// components

import CardStats from "../Cards/CardStats.js";

export default function HeaderWithoutStats() {
  return (
    <>
      {/* Header */}
      <div className="relative bg-indigo-600 md:pt-32 pt-12">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
           
          </div>
        </div>
      </div>
    </>
  );
}
